export default __webpack_public_path__ + "static/media/user-cog-icon.72554c80.svg";